module.exports = __webpack_public_path__ + "static/img/10.7882ada.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/8/1/1/eng/10.png
// module id = VTxo
// module chunks = 0